import { useMemo } from "react";
import compact from "lodash/compact";
import uniq from "lodash/uniq";
import useFieldTypesUnits from "views/hooks/useFieldTypesUnits";
import { parseSeries } from "views/logic/aggregationbuilder/Series";
const useWidgetUnits = (config) => {
  const fieldTypesUnits = useFieldTypesUnits();
  const usedFieldsInSeries = useMemo(
    () => config.series.map((s) => {
      var _a;
      const { field } = (_a = parseSeries(s.function)) != null ? _a : {};
      return field;
    }),
    [config.series]
  );
  const usedFieldsInRowPivots = useMemo(() => config.rowPivots.flatMap((p) => p.fields), [config.rowPivots]);
  const usedFieldsInColumnPivots = useMemo(() => config.columnPivots.flatMap((p) => p.fields), [config.columnPivots]);
  const allFields = useMemo(
    () => uniq(compact([...usedFieldsInSeries, ...usedFieldsInRowPivots, ...usedFieldsInColumnPivots])),
    [usedFieldsInColumnPivots, usedFieldsInRowPivots, usedFieldsInSeries]
  );
  const widgetUnits = config.units;
  const filteredFields = Object.fromEntries(
    allFields.filter((field) => {
      const predefinedUnit = fieldTypesUnits == null ? void 0 : fieldTypesUnits[field];
      return !(widgetUnits == null ? void 0 : widgetUnits.getFieldUnit(field)) && !!predefinedUnit;
    }).map((field) => {
      const predefinedUnit = fieldTypesUnits == null ? void 0 : fieldTypesUnits[field];
      return [field, predefinedUnit];
    })
  );
  return widgetUnits.toBuilder().merge(filteredFields).build();
};
export default useWidgetUnits;
